<div class="section form-group">
    <label class="section-title" *ngIf="isHomeNotAddress || isOutsideHome" [ngClass]="{'section-header sub-section-header mox-ui-font-size-16': claim.isMox()}">{{'claimDetails.body.claimDetails' | translate}}</label>
    <label class="section-title" *ngIf="!isHomeNotAddress && !isOutsideHome" [ngClass]="{'section-header sub-section-header mox-ui-font-size-16': claim.isMox()}">{{'homeProduct.others.title' | translate}}</label>
    <div class="section-content">
        <div class="sub-section">

            <div class="row">
                <div class="col col-xs-12 col-lg-7">
                    {{'claimDetails.generic.descOfIncident' | translate}}
                </div>
                <div class="col col-xs-12 col-lg-5-word-break content">
                    {{this.otherDetails.getDescIncident()}}
                </div>
            </div>

            <div class="row" *ngIf="this.otherDetails.getEstAmountLoss()">
                <div class="col col-xs-12 col-lg-7">
                    {{'claimDetails.generic.estAmtLoss' | translate}}
                </div>
                <div class="col col-xs-12 col-lg-5 content">
                    {{this.otherDetails.getEstAmountLossCurrency()}}
                    {{this.otherDetails.getEstAmountLoss() | number : '1.2-2'}}
                </div>
            </div>
        </div>
    </div>
</div>